export const JackpotSourcesEnum = {
    PARI_PLAY: 'pp',
    NG_PJP: 'ng-pjp',
};
